<template>
  <v-card class="mb-3" elevation="0">
    <v-card-title class="portal-deep-blue-bg">
      Contract data
    </v-card-title>
    
    <v-card-text class="mt-5">
      <v-simple-table class="dp-gray" dense>
        <template v-slot:default>
          <thead></thead>
          <tbody>
            <tr>
              <th class="text-left shrink" colspan="2">Constructor warranty</th>
              <td colspan="2">{{ asset?.asset?.warranty }}</td>
            </tr>
            <tr>
              <th class="text-left shrink" colspan="2">ECM3 person</th>
              <td colspan="2">{{ asset?.asset?.ecm3person }}</td>
            </tr>
            <tr>
              <th class="text-left shrink" colspan="2">ECM3 deputy</th>
              <td colspan="2">{{ asset?.asset?.ecm3deputy }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props:['asset']
}
</script>